module.exports = "/work-site/img/collapse_panel.705f8c21.png";